import { makeAutoObservable, runInAction } from 'mobx';
import { showToast } from '../../../utils/toast';
import { SBTI_INITIAL } from '../constants/onboard.constant';
import { _handleGetYearOptions, calculateTargetReduction } from '../utils/onboard.util';
import { sbtiURL } from '../api/url';
import { handleFetch } from '../../../utils/handleFetch';

class SBTiStore {
	SBTiSettingForm = SBTI_INITIAL;
	isSBTiChanged = false;
	initialYear = 2024;
	currentYear = new Date().getFullYear();
	baseYearOptions = [];
	targetYearOptions = [];

	constructor() {
		makeAutoObservable(this);
	}

	getSBTI = async () => {
		return await handleFetch({
			url: sbtiURL,
			method: 'GET',
			onSuccess: (data) => runInAction(() => (this.SBTiSettingForm = data)),
		});
	};

	saveSBTI = async () => {
		return showToast.promise(
			(async () => {
				const success = await handleFetch({
					url: sbtiURL,
					method: 'PUT',
					body: this.SBTiSettingForm,
					onSuccess: (data) => {
						runInAction(() => {
							this.SBTiSettingForm = data;
							this.isSBTiChanged = false;
						});
					},
				});
				if (!success) throw new Error('Failed to save SBTi');
				return success;
			})(),
			{
				loading: 'Saving SBTi settings...',
				success: 'SBTi settings saved successfully!',
				error: 'Failed to save SBTi settings',
			},
		);
	};

	handleGetBaseYearOptions = () => {
		this.baseYearOptions = _handleGetYearOptions(2020, this.currentYear);
	};

	handleGetTargetYearOptions = () => {
		this.targetYearOptions = _handleGetYearOptions(this.currentYear + 1, this.currentYear + 10);
	};

	handleChangeSBTiSetting = (e) => {
		const { id, value } = e.target;
		this.SBTiSettingForm[id] = value;
		this.isSBTiChanged = true;
	};

	handleCheckReductionScope = (e) => {
		this.isSBTiChanged = true;
		const { id, value } = e.target;
		const [key1, key2] = id.split('_');

		if (!this.SBTiSettingForm.reductionScopes) {
			this.SBTiSettingForm.reductionScopes = {};
		}
		if (!this.SBTiSettingForm.reductionScopes[key1]) {
			this.SBTiSettingForm.reductionScopes[key1] = {};
		}

		this.SBTiSettingForm.reductionScopes[key1][key2] = value;
	};

	get getTotalTargetReduction() {
		const { reductionScopes = {} } = this.SBTiSettingForm || {};
		const total = Object.entries(reductionScopes).reduce((acc, [key, { isSelect, baseline }]) => {
			return isSelect ? acc + (Number(baseline) || 0) : acc;
		}, 0);

		const totalTargetReduction = total * (Number(calculateTargetReduction(this.SBTiSettingForm)) / 100 || 1);

		return totalTargetReduction;
	}

	get totalReductionBaseline() {
		const { reductionScopes = {} } = this.SBTiSettingForm || {};
		return Object.entries(reductionScopes).reduce((a, [key, { isSelect, baseline }]) => {
			if (key === '_id') return a;
			const value = isSelect ? parseFloat(baseline) || 0 : 0;
			return a + value;
		}, 0);
	}
}

export const sbtiStore = new SBTiStore();
